<template>
  <div>
    <div v-if="showGeneralErrorMessage && !fetching" :class="$style.errorMessage">
      <IconSelect
        :class="$style.errorIcon"
        icon="info"
        :height="24"
        :width="24"
        :icon-props="{ 'stroke-width': 2 }"
      />
      <span :class="$style.errorText">{{ generalErrorMessage }}</span>
    </div>
    <div v-if="showSuccessMessage && !fetching" :class="$style.successMessage">
      <IconSelect
        :class="$style.successIcon"
        icon="info"
        :height="24"
        :width="24"
        :icon-props="{ 'stroke-width': 2 }"
      />
      <span :class="$style.successText">{{ successMessage }}</span>
    </div>
  </div>
</template>

<script>
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'FormResultMessage',
  components: {
    IconSelect,
  },
  props: {
    fetching: {
      type: Boolean,
      default: false,
    },
    showGeneralErrorMessage: {
      type: Boolean,
      default: false,
    },
    showSuccessMessage: {
      type: Boolean,
      default: false,
    },
    generalErrorMessage: {
      type: String,
      default: '',
    },
    successMessage: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" module>
.errorMessage {
  display: flex;
  align-items: end;
  align-items: center;
  justify-content: center;
  padding: 1rem 1rem;

  color: var(--red);

  background: #ffbaba;
  border: 2px solid var(--red);
  border-radius: 0.5rem;

  fill: var(--red);
  stroke: var(--red);
}

.successMessage {
  display: flex;
  align-items: end;
  align-items: center;
  justify-content: center;
  padding: 1rem 1rem;

  color: var(--green-darken-1);

  background: mintcream;
  border: 2px solid var(--green-darken-1);
  border-radius: 0.5rem;
  opacity: 90%;

  fill: var(--green-darken-1);
  stroke: var(--green-darken-1);
}

.successIcon {
  margin-right: 10px;
}

.successText {
  opacity: 100% !important;
}

.errorIcon {
  margin-right: 10px;
}

.errorText {
  opacity: 100% !important;
}
</style>
